// extracted by mini-css-extract-plugin
export default {"container":"PointHeader_container__7fx5L","title":"PointHeader_title__hP04H","point":"PointHeader_point__bH+07","number":"PointHeader_number__NGSVt","text":"PointHeader_text__5HqZG"};